<template>
  <div>
    <v-container fluid tag="section" class="tabs py-0 pt-1">
      <v-tabs v-model="tab" background-color="transparent" show-arrows height="40">
        <v-tab href="#profile" active-class="v-tab-active-class">
          {{ $t('views.myAccount.profile') }}
        </v-tab>
        <v-tab href="#billing" active-class="v-tab-active-class">
          {{ $t('views.myAccount.billing.title') }}
        </v-tab>
        <v-tab href="#preferences" active-class="v-tab-active-class">
          {{ $t('views.myAccount.preferences') }}
        </v-tab>
        <template v-if="!isPartnerRoleUser">
          <v-tab href="#referral" active-class="v-tab-active-class">
            {{ $t('views.myAccount.partner.title.referral') }}
          </v-tab>
        </template>
        <template v-else-if="showPartnerSection">
          <v-tab href="#partner" active-class="v-tab-active-class">
            {{ $t('views.myAccount.partner.title.partner') }}
          </v-tab>
        </template>
      </v-tabs>
    </v-container>

    <v-container fluid tag="section" class="tabs-items pb-10">
      <v-tabs-items v-model="tab" class="transparent-background" touchless>
        <v-tab-item value="profile" :transition="false" :reverse-transition="false">
          <AccountProfilePersonal />
        </v-tab-item>
        <v-tab-item value="billing" :transition="false" :reverse-transition="false">
          <AccountProfileBilling />
        </v-tab-item>
        <v-tab-item value="preferences" :transition="false" :reverse-transition="false">
          <AccountPreferences />
        </v-tab-item>
        <template v-if="!isPartnerRoleUser">
          <v-tab-item value="referral" :transition="false" :reverse-transition="false">
            <AccountPartner type="referral" />
          </v-tab-item>
        </template>
        <template v-else-if="showPartnerSection">
          <v-tab-item value="partner" :transition="false" :reverse-transition="false">
            <AccountPartner type="partner" />
          </v-tab-item>
        </template>
      </v-tabs-items>
    </v-container>

    <UpgradeCompleteModal
      :isModalActive.sync="isUpgradeCompleteModalActive"
      :completePlan="completePlan"
      @updateUser="updateUsersInfo"
    />
  </div>
</template>

<script>
import { get } from 'lodash'
import { mapActions, mapGetters, mapState } from 'vuex'
import gtag from '@/lib/gtag'
import AccountProfileBilling from '@/views/components/account/AccountProfileBilling'
import AccountProfilePersonal from '@/views/components/account/AccountProfilePersonal'
import AccountPreferences from '@/views/components/account/AccountPreferences'
import AccountPartner from '@/views/components/account/AccountPartner'
import UpgradeCompleteModal from '@/views/components/common/UpgradeCompleteModal'

export default {
  components: {
    AccountProfileBilling,
    AccountProfilePersonal,
    AccountPreferences,
    AccountPartner,
    UpgradeCompleteModal,
  },
  data: () => ({
    tab: null,
    isUpgradeCompleteModalActive: false,
    completePlan: null,
  }),
  computed: {
    ...mapState(['user']),
    ...mapGetters(['isPartnerRoleUser']),
    showPartnerSection() {
      if (!this.isPartnerRoleUser) return false
      return get(this.user, 'partnerInfo.showPartnerSection', undefined)
    },
  },
  watch: {
    tab() {
      gtag.pageview({
        pagePath: `/account/${this.tab}`,
        pageTitle: `account|${this.tab}`,
        pageContentGroup: 'page',
      })
    },
    '$route.query': {
      async handler() {
        if (this.$route.query.tab) {
          this.tab = this.$route.query.tab
        }

        if (this.$route.query.session_id && this.$route.query.plan) {
          this.tab = 'billing'
          this.completePlan = this.$route.query.plan
          this.isUpgradeCompleteModalActive = true

          gtag.pageview({
            pagePath: `/account/billing/checkout-completed`,
            pageTitle: `account|billing|checkout-completed`,
            pageContentGroup: 'modal',
          })
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    ...mapActions({ updateUsersInfo: 'UPDATE_USERS_INFO' }),
  },
}
</script>
